import React, { useCallback } from 'react';

import data from './data';
import { sections } from '../../../common/config';
import { Section, Container } from '../styled';
import Heading from '../../../components/Heading';
import Accordion from './Accordion';
import useFlavorStore from '../../../common/store/useFlavorStore';

const Flavor = () => {
  const flavor = useFlavorStore(useCallback(state => state.flavor, []));

  return (
    <Section
      $height={sections.height.flavor}
      $align="start"
    >
      <Container $primary>

        <Heading number="03" label="Pick your cider" align="left" />

        {data.map((item, i) =>
          <Accordion
            key={i}
            name={item.name}
            flavor={item.flavor}
            calorie={item.calorie}
            taste={item.taste}
            aroma={item.aroma}
            pairsWell={item.pairsWell}
            active={item.flavor === flavor}
          />
        )}

      </Container>
    </Section>
  );
}

export default React.memo(Flavor);